import { Directive, HostBinding, HostListener, inject } from '@angular/core';
import { ModalService } from './modal.service';

@Directive({
  selector: '[panModalClose]',
  standalone: false,
})
export class PanModalCloseDirective {
  private modalService = inject(ModalService);

  @HostBinding('attr.aria-label')
  public get ariaLabel() {
    return 'Close modal';
  }

  @HostListener('click') onClick() {
    this.modalService.removeModal();
  }
}
